export const getIds = (list: any) => {
    return list.map((elem: any): number => {
        return elem.id as number;
    });
};
